export default __webpack_public_path__ + "static/media/krwawnik.c192a771.svg";